import { MyInformations } from 'app/components/profile/my-informations';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { useNavigationOptions } from 'app/hooks/navigation';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { usePageTitle } from 'app/utils/web-helpers';
import React, { useEffect } from 'react';

export { getSchema } from './schema';

const MyInformationScreenComponent: NavigationScreen<'my-information'> = ({ navigation }) => {
  const { t } = useScopedTranslation();

  const headerTitle = () => (
    <Text variant="bodyXLargeMedium" color="white-label.header.on-header">
      {t(`myInformationButtonLabel`, { ns: 'profile-overview' })}
    </Text>
  );

  const setPageTitle = usePageTitle('profile-overview');
  useEffect(() => setPageTitle('myInformationButtonLabel'), [setPageTitle]);

  useNavigationOptions(navigation, {
    headerTitle,
  });

  return <MyInformations />;
};

export const MyInformationScreen: NavigationScreen<'my-information'> = withOptionalMetrics(
  'MyInformationScreen',
  MyInformationScreenComponent,
);
